import React from 'react';

import { useQuery } from '@tanstack/react-query';

import Account from '../../components/Account';

import ServicerService from '../../services/ServicerService';
import AuthService from '../../services/AuthService';
import logoBlack from '../../assets/images/logo-black.png';

const getUserRole = (servicer, me, isSuperAdmin) => {
  if (isSuperAdmin) {
    return 'Admin';
  }

  // eslint-disable-next-line no-shadow
  const role = me?._roles.find((role) => role.servicer_id === servicer.id);

  return role?.access?.[0]?.object_type;
};

export default function AccountPage() {
  const { data: servicers } = useQuery({
    queryKey: ['servicers'],
    queryFn: ServicerService.getServicers,
  });

  const { data: me } = useQuery({
    queryKey: ['me'],
    queryFn: AuthService.getMe,
  });

  const isSuperAdmin = me?.is_super;

  const availableServicers = isSuperAdmin
    ? servicers
    : servicers?.filter((servicer) =>
        me?._roles.some((role) => role.servicer_id === servicer.id)
      );

  // Sort by id in ascending order
  const servicersToDisplay = availableServicers?.sort((a, b) => a.id - b.id);

  return (
    <main className="grow">
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        {/* Page header */}
        <div className="sm:flex sm:justify-between sm:items-center mb-8">
          {/* Left: Title */}
          <div className="mb-4 sm:mb-0">
            <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
              Accounts
            </h1>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-12 gap-6">
          {isSuperAdmin && (
            <Account
              name="Super Admin"
              image={logoBlack}
              link="https://admin.pixelservicing.com"
            />
          )}

          {servicersToDisplay?.map((servicer) => {
            const link = servicer.domain
              ? `https://${servicer.domain}`
              : `https://${servicer.subdomain}.pixelservicing.com`;

            const role = getUserRole(servicer, me, isSuperAdmin);

            return (
              <Account
                key={servicer.id}
                id={servicer.id}
                userRole={role}
                name={servicer.name}
                image={servicer.logo_secondary?.url}
                link={link}
              />
            );
          })}
        </div>
      </div>
    </main>
  );
}
